// stores/ContextMenuProviderStore.ts
import {makeAutoObservable} from 'mobx';
import {ReactNode} from 'react';

interface MenuState {
  content: ReactNode;
  position: {x: number; y: number};
}

class ContextMenuProviderStore {
  public menu: MenuState | null = null;

  constructor() {
    makeAutoObservable(this);
  }

  public show(content: ReactNode, position: {x: number; y: number}) {
    this.menu = {content, position};
  }

  public close() {
    this.menu = null;
  }
}

export default ContextMenuProviderStore;
